export const exampleTestClaims: Array<string> = [
  '1950s "Atomic Energy Lab" Kit for Kids Used Real Radioactive Materials',
  'Women are less suited to work in STEM',
  'The UK spends 2.5% of GDP on defence',
  'A protein in human saliva called Histatin can help wounds heal faster',
  'The Antarctic ice cap is not melting',
];
